var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTiledBackground = function SvgTiledBackground(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "111.11428mm",
    height: "93.209686mm",
    viewBox: "0 0 111.11428 93.209686",
    id: "svg5",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-2.0248735,-32.727096)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4647"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      fillRule: "evenodd"
    },
    id: "g83",
    transform: "matrix(0.01664391,0,0,0.01664391,5.6328219,54.899581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3023",
    transform: "translate(269.81467,-650.62904)",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m -126.267,1038.85 c 22.737,50.44 15.792,102.75 -15.51,116.87 -31.303,14.12 -75.11,-15.31 -97.845,-65.74 -22.737,-50.43 -15.793,-102.745 15.51,-116.863 31.303,-14.114 75.108,15.317 97.845,65.733 z",
    id: "path3025"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 183.155,1038.85 c -22.738,50.44 -15.793,102.75 15.512,116.87 31.303,14.12 75.106,-15.31 97.846,-65.74 22.734,-50.43 15.789,-102.745 -15.513,-116.863 -31.301,-14.114 -75.108,15.317 -97.845,65.733 z",
    id: "path3027"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 6.7856,937.757 c 11.6548,54.069 -6.1108,103.763 -39.6787,111.003 -33.5654,7.23 -70.2249,-30.74 -81.8779,-84.804 -11.653,-54.068 6.112,-103.764 39.6792,-110.997 33.5669,-7.236 70.2246,30.729 81.8774,84.798 z",
    id: "path3029"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 49.2676,937.803 c -11.6446,54.068 6.1084,103.767 39.6738,110.997 33.5676,7.24 70.2256,-30.73 81.8776,-84.797 11.654,-54.069 -6.109,-103.765 -39.678,-110.998 -33.5678,-7.234 -70.225,30.729 -81.8734,84.798 z",
    id: "path3031"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m -35.2275,1118.5 c -8.1924,14.15 -46.1563,60.99 -72.4145,76.97 -26.256,15.98 -58.792,39.38 -53.332,93.11 5.457,53.74 60.575,76.74 96.8597,74.7 36.2867,-2.03 104.6993,-8.71 153.543,-1.94 48.8413,6.77 110.4863,1.64 124.9223,-49.81 14.436,-51.45 -17.85,-84.23 -43.044,-102.83 -25.193,-18.59 -67.265,-74.2 -80.2269,-99.73 -12.96,-25.52 -78.9268,-72.26 -126.3076,9.53 z",
    id: "path3033"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      fillRule: "evenodd"
    },
    id: "g83-7",
    transform: "matrix(0.01282883,0.01060381,-0.01060381,0.01282883,34.366523,66.977882)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3023-9",
    transform: "translate(269.81467,-650.62904)",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m -126.267,1038.85 c 22.737,50.44 15.792,102.75 -15.51,116.87 -31.303,14.12 -75.11,-15.31 -97.845,-65.74 -22.737,-50.43 -15.793,-102.745 15.51,-116.863 31.303,-14.114 75.108,15.317 97.845,65.733 z",
    id: "path3025-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 183.155,1038.85 c -22.738,50.44 -15.793,102.75 15.512,116.87 31.303,14.12 75.106,-15.31 97.846,-65.74 22.734,-50.43 15.789,-102.745 -15.513,-116.863 -31.301,-14.114 -75.108,15.317 -97.845,65.733 z",
    id: "path3027-8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 6.7856,937.757 c 11.6548,54.069 -6.1108,103.763 -39.6787,111.003 -33.5654,7.23 -70.2249,-30.74 -81.8779,-84.804 -11.653,-54.068 6.112,-103.764 39.6792,-110.997 33.5669,-7.236 70.2246,30.729 81.8774,84.798 z",
    id: "path3029-0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 49.2676,937.803 c -11.6446,54.068 6.1084,103.767 39.6738,110.997 33.5676,7.24 70.2256,-30.73 81.8776,-84.797 11.654,-54.069 -6.109,-103.765 -39.678,-110.998 -33.5678,-7.234 -70.225,30.729 -81.8734,84.798 z",
    id: "path3031-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m -35.2275,1118.5 c -8.1924,14.15 -46.1563,60.99 -72.4145,76.97 -26.256,15.98 -58.792,39.38 -53.332,93.11 5.457,53.74 60.575,76.74 96.8597,74.7 36.2867,-2.03 104.6993,-8.71 153.543,-1.94 48.8413,6.77 110.4863,1.64 124.9223,-49.81 14.436,-51.45 -17.85,-84.23 -43.044,-102.83 -25.193,-18.59 -67.265,-74.2 -80.2269,-99.73 -12.96,-25.52 -78.9268,-72.26 -126.3076,9.53 z",
    id: "path3033-4"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      fillRule: "evenodd"
    },
    id: "g83-7-3",
    transform: "matrix(0.01176503,0.011773,-0.011773,0.01176503,37.509302,28.437833)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3023-9-9",
    transform: "translate(269.81467,-650.62904)",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m -126.267,1038.85 c 22.737,50.44 15.792,102.75 -15.51,116.87 -31.303,14.12 -75.11,-15.31 -97.845,-65.74 -22.737,-50.43 -15.793,-102.745 15.51,-116.863 31.303,-14.114 75.108,15.317 97.845,65.733 z",
    id: "path3025-3-9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 183.155,1038.85 c -22.738,50.44 -15.793,102.75 15.512,116.87 31.303,14.12 75.106,-15.31 97.846,-65.74 22.734,-50.43 15.789,-102.745 -15.513,-116.863 -31.301,-14.114 -75.108,15.317 -97.845,65.733 z",
    id: "path3027-8-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 6.7856,937.757 c 11.6548,54.069 -6.1108,103.763 -39.6787,111.003 -33.5654,7.23 -70.2249,-30.74 -81.8779,-84.804 -11.653,-54.068 6.112,-103.764 39.6792,-110.997 33.5669,-7.236 70.2246,30.729 81.8774,84.798 z",
    id: "path3029-0-0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 49.2676,937.803 c -11.6446,54.068 6.1084,103.767 39.6738,110.997 33.5676,7.24 70.2256,-30.73 81.8776,-84.797 11.654,-54.069 -6.109,-103.765 -39.678,-110.998 -33.5678,-7.234 -70.225,30.729 -81.8734,84.798 z",
    id: "path3031-2-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m -35.2275,1118.5 c -8.1924,14.15 -46.1563,60.99 -72.4145,76.97 -26.256,15.98 -58.792,39.38 -53.332,93.11 5.457,53.74 60.575,76.74 96.8597,74.7 36.2867,-2.03 104.6993,-8.71 153.543,-1.94 48.8413,6.77 110.4863,1.64 124.9223,-49.81 14.436,-51.45 -17.85,-84.23 -43.044,-102.83 -25.193,-18.59 -67.265,-74.2 -80.2269,-99.73 -12.96,-25.52 -78.9268,-72.26 -126.3076,9.53 z",
    id: "path3033-4-9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      fillRule: "evenodd"
    },
    id: "g83-7-8",
    transform: "matrix(0.01519688,-0.00678782,0.00678782,0.01519688,57.489431,75.326361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3023-9-6",
    transform: "translate(269.81467,-650.62904)",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m -126.267,1038.85 c 22.737,50.44 15.792,102.75 -15.51,116.87 -31.303,14.12 -75.11,-15.31 -97.845,-65.74 -22.737,-50.43 -15.793,-102.745 15.51,-116.863 31.303,-14.114 75.108,15.317 97.845,65.733 z",
    id: "path3025-3-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 183.155,1038.85 c -22.738,50.44 -15.793,102.75 15.512,116.87 31.303,14.12 75.106,-15.31 97.846,-65.74 22.734,-50.43 15.789,-102.745 -15.513,-116.863 -31.301,-14.114 -75.108,15.317 -97.845,65.733 z",
    id: "path3027-8-76"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 6.7856,937.757 c 11.6548,54.069 -6.1108,103.763 -39.6787,111.003 -33.5654,7.23 -70.2249,-30.74 -81.8779,-84.804 -11.653,-54.068 6.112,-103.764 39.6792,-110.997 33.5669,-7.236 70.2246,30.729 81.8774,84.798 z",
    id: "path3029-0-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 49.2676,937.803 c -11.6446,54.068 6.1084,103.767 39.6738,110.997 33.5676,7.24 70.2256,-30.73 81.8776,-84.797 11.654,-54.069 -6.109,-103.765 -39.678,-110.998 -33.5678,-7.234 -70.225,30.729 -81.8734,84.798 z",
    id: "path3031-2-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m -35.2275,1118.5 c -8.1924,14.15 -46.1563,60.99 -72.4145,76.97 -26.256,15.98 -58.792,39.38 -53.332,93.11 5.457,53.74 60.575,76.74 96.8597,74.7 36.2867,-2.03 104.6993,-8.71 153.543,-1.94 48.8413,6.77 110.4863,1.64 124.9223,-49.81 14.436,-51.45 -17.85,-84.23 -43.044,-102.83 -25.193,-18.59 -67.265,-74.2 -80.2269,-99.73 -12.96,-25.52 -78.9268,-72.26 -126.3076,9.53 z",
    id: "path3033-4-0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      fillRule: "evenodd"
    },
    id: "g83-7-1",
    transform: "matrix(0.01657236,-0.00154164,0.00154164,0.01657236,14.980405,97.251593)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3023-9-7",
    transform: "translate(269.81467,-650.62904)",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m -126.267,1038.85 c 22.737,50.44 15.792,102.75 -15.51,116.87 -31.303,14.12 -75.11,-15.31 -97.845,-65.74 -22.737,-50.43 -15.793,-102.745 15.51,-116.863 31.303,-14.114 75.108,15.317 97.845,65.733 z",
    id: "path3025-3-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 183.155,1038.85 c -22.738,50.44 -15.793,102.75 15.512,116.87 31.303,14.12 75.106,-15.31 97.846,-65.74 22.734,-50.43 15.789,-102.745 -15.513,-116.863 -31.301,-14.114 -75.108,15.317 -97.845,65.733 z",
    id: "path3027-8-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 6.7856,937.757 c 11.6548,54.069 -6.1108,103.763 -39.6787,111.003 -33.5654,7.23 -70.2249,-30.74 -81.8779,-84.804 -11.653,-54.068 6.112,-103.764 39.6792,-110.997 33.5669,-7.236 70.2246,30.729 81.8774,84.798 z",
    id: "path3029-0-6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 49.2676,937.803 c -11.6446,54.068 6.1084,103.767 39.6738,110.997 33.5676,7.24 70.2256,-30.73 81.8776,-84.797 11.654,-54.069 -6.109,-103.765 -39.678,-110.998 -33.5678,-7.234 -70.225,30.729 -81.8734,84.798 z",
    id: "path3031-2-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m -35.2275,1118.5 c -8.1924,14.15 -46.1563,60.99 -72.4145,76.97 -26.256,15.98 -58.792,39.38 -53.332,93.11 5.457,53.74 60.575,76.74 96.8597,74.7 36.2867,-2.03 104.6993,-8.71 153.543,-1.94 48.8413,6.77 110.4863,1.64 124.9223,-49.81 14.436,-51.45 -17.85,-84.23 -43.044,-102.83 -25.193,-18.59 -67.265,-74.2 -80.2269,-99.73 -12.96,-25.52 -78.9268,-72.26 -126.3076,9.53 z",
    id: "path3033-4-5"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      fillRule: "evenodd"
    },
    id: "g83-7-4",
    transform: "matrix(0.01282883,0.01060381,-0.01060381,0.01282883,91.122446,52.111024)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3023-9-71",
    transform: "translate(269.81467,-650.62904)",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m -126.267,1038.85 c 22.737,50.44 15.792,102.75 -15.51,116.87 -31.303,14.12 -75.11,-15.31 -97.845,-65.74 -22.737,-50.43 -15.793,-102.745 15.51,-116.863 31.303,-14.114 75.108,15.317 97.845,65.733 z",
    id: "path3025-3-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 183.155,1038.85 c -22.738,50.44 -15.793,102.75 15.512,116.87 31.303,14.12 75.106,-15.31 97.846,-65.74 22.734,-50.43 15.789,-102.745 -15.513,-116.863 -31.301,-14.114 -75.108,15.317 -97.845,65.733 z",
    id: "path3027-8-8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 6.7856,937.757 c 11.6548,54.069 -6.1108,103.763 -39.6787,111.003 -33.5654,7.23 -70.2249,-30.74 -81.8779,-84.804 -11.653,-54.068 6.112,-103.764 39.6792,-110.997 33.5669,-7.236 70.2246,30.729 81.8774,84.798 z",
    id: "path3029-0-4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 49.2676,937.803 c -11.6446,54.068 6.1084,103.767 39.6738,110.997 33.5676,7.24 70.2256,-30.73 81.8776,-84.797 11.654,-54.069 -6.109,-103.765 -39.678,-110.998 -33.5678,-7.234 -70.225,30.729 -81.8734,84.798 z",
    id: "path3031-2-8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m -35.2275,1118.5 c -8.1924,14.15 -46.1563,60.99 -72.4145,76.97 -26.256,15.98 -58.792,39.38 -53.332,93.11 5.457,53.74 60.575,76.74 96.8597,74.7 36.2867,-2.03 104.6993,-8.71 153.543,-1.94 48.8413,6.77 110.4863,1.64 124.9223,-49.81 14.436,-51.45 -17.85,-84.23 -43.044,-102.83 -25.193,-18.59 -67.265,-74.2 -80.2269,-99.73 -12.96,-25.52 -78.9268,-72.26 -126.3076,9.53 z",
    id: "path3033-4-04"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      fillRule: "evenodd"
    },
    id: "g83-7-6",
    transform: "matrix(0.01282883,0.01060381,-0.01060381,0.01282883,99.2966,95.70651)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3023-9-0",
    transform: "translate(269.81467,-650.62904)",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m -126.267,1038.85 c 22.737,50.44 15.792,102.75 -15.51,116.87 -31.303,14.12 -75.11,-15.31 -97.845,-65.74 -22.737,-50.43 -15.793,-102.745 15.51,-116.863 31.303,-14.114 75.108,15.317 97.845,65.733 z",
    id: "path3025-3-32"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 183.155,1038.85 c -22.738,50.44 -15.793,102.75 15.512,116.87 31.303,14.12 75.106,-15.31 97.846,-65.74 22.734,-50.43 15.789,-102.745 -15.513,-116.863 -31.301,-14.114 -75.108,15.317 -97.845,65.733 z",
    id: "path3027-8-6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 6.7856,937.757 c 11.6548,54.069 -6.1108,103.763 -39.6787,111.003 -33.5654,7.23 -70.2249,-30.74 -81.8779,-84.804 -11.653,-54.068 6.112,-103.764 39.6792,-110.997 33.5669,-7.236 70.2246,30.729 81.8774,84.798 z",
    id: "path3029-0-9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 49.2676,937.803 c -11.6446,54.068 6.1084,103.767 39.6738,110.997 33.5676,7.24 70.2256,-30.73 81.8776,-84.797 11.654,-54.069 -6.109,-103.765 -39.678,-110.998 -33.5678,-7.234 -70.225,30.729 -81.8734,84.798 z",
    id: "path3031-2-4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m -35.2275,1118.5 c -8.1924,14.15 -46.1563,60.99 -72.4145,76.97 -26.256,15.98 -58.792,39.38 -53.332,93.11 5.457,53.74 60.575,76.74 96.8597,74.7 36.2867,-2.03 104.6993,-8.71 153.543,-1.94 48.8413,6.77 110.4863,1.64 124.9223,-49.81 14.436,-51.45 -17.85,-84.23 -43.044,-102.83 -25.193,-18.59 -67.265,-74.2 -80.2269,-99.73 -12.96,-25.52 -78.9268,-72.26 -126.3076,9.53 z",
    id: "path3033-4-1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      fillRule: "evenodd"
    },
    id: "g83-7-37",
    transform: "matrix(0.01580468,0.00521842,-0.00521842,0.01580468,54.203906,109.89145)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3023-9-8",
    transform: "translate(269.81467,-650.62904)",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m -126.267,1038.85 c 22.737,50.44 15.792,102.75 -15.51,116.87 -31.303,14.12 -75.11,-15.31 -97.845,-65.74 -22.737,-50.43 -15.793,-102.745 15.51,-116.863 31.303,-14.114 75.108,15.317 97.845,65.733 z",
    id: "path3025-3-8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 183.155,1038.85 c -22.738,50.44 -15.793,102.75 15.512,116.87 31.303,14.12 75.106,-15.31 97.846,-65.74 22.734,-50.43 15.789,-102.745 -15.513,-116.863 -31.301,-14.114 -75.108,15.317 -97.845,65.733 z",
    id: "path3027-8-38"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 6.7856,937.757 c 11.6548,54.069 -6.1108,103.763 -39.6787,111.003 -33.5654,7.23 -70.2249,-30.74 -81.8779,-84.804 -11.653,-54.068 6.112,-103.764 39.6792,-110.997 33.5669,-7.236 70.2246,30.729 81.8774,84.798 z",
    id: "path3029-0-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 49.2676,937.803 c -11.6446,54.068 6.1084,103.767 39.6738,110.997 33.5676,7.24 70.2256,-30.73 81.8776,-84.797 11.654,-54.069 -6.109,-103.765 -39.678,-110.998 -33.5678,-7.234 -70.225,30.729 -81.8734,84.798 z",
    id: "path3031-2-53"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m -35.2275,1118.5 c -8.1924,14.15 -46.1563,60.99 -72.4145,76.97 -26.256,15.98 -58.792,39.38 -53.332,93.11 5.457,53.74 60.575,76.74 96.8597,74.7 36.2867,-2.03 104.6993,-8.71 153.543,-1.94 48.8413,6.77 110.4863,1.64 124.9223,-49.81 14.436,-51.45 -17.85,-84.23 -43.044,-102.83 -25.193,-18.59 -67.265,-74.2 -80.2269,-99.73 -12.96,-25.52 -78.9268,-72.26 -126.3076,9.53 z",
    id: "path3033-4-54"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g4315",
    transform: "matrix(-0.03876891,-0.0055023,0.0055023,-0.03876891,83.979334,118.27267)",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4286",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 189.3,365.01 c 0.57573,-7.0728 1.2016,-14.675 3.4515,-21.457 1.1551,-4.5503 3.4106,-8.7096 6.0026,-12.454 2.4714,-3.8699 8.1778,-6.1382 12.906,-4.3126 3.2533,1.2939 6.0561,3.833 8.1035,6.7133 3.1524,3.6637 4.6858,8.384 7.0332,12.454 2.58,5.2257 4.0104,10.982 5.7317,16.449 2.455,12.109 -0.76216,23.41 -10.678,28.817 -5.7092,3.4104 -13.792,3.9326 -20.095,1.4123 -4.3846,-1.6569 -7.1757,-5.4805 -9.4207,-9.3164 -2.9209,-5.6183 -4.222,-11.606 -3.2662,-18.123 l 0.23149,-0.18287 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4282",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 190.17,429.23 c 1.8305,-10.761 9.095,-19.649 18.068,-25.486 8.1612,-5.6492 16.957,-10.343 24.846,-16.299 5.0561,-5.6645 7.5158,-13.066 12.016,-19.193 7.4832,-8.8846 19.856,-11.395 30.947,-11.981 14.204,-0.51947 30.236,-0.34628 41.631,9.3822 6.5878,6.4913 8.2315,16.516 15.533,22.464 6.9948,5.5855 14.891,9.5602 22.212,14.701 10.092,6.723 19.494,17.094 19.513,29.944 0.2958,10.041 -3.52,19.939 -8.4946,28.495 -5.336,8.2918 -14.886,13.359 -24.779,12.629 -10.358,0.13126 -19.625,-5.5392 -29.789,-6.2218 -10.044,2.4158 -20.507,3.8886 -30.939,3.5049 -9.943,0.68229 -19.614,-2.4005 -29.261,-3.4278 -11.993,2.088 -23.85,8.0595 -36.291,5.5099 -11.182,-2.586 -18.883,-12.441 -21.998,-23.085 -2.3944,-6.5221 -4.7622,-13.984 -3.2138,-20.936 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4268",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 222.31,321.2 c 0.35791,-8.8604 1.8491,-17.553 3.9066,-26.22 3.4303,-11.533 7.3346,-25.939 19.845,-30.408 11.895,-1.8783 19.499,10.821 23.57,20.379 5.7808,13.224 9.8212,27.381 11.185,41.782 0.72297,13.299 -11.116,22.493 -23.192,24.413 -11.061,3.3232 -24.427,-0.33332 -30.314,-10.858 -3.7042,-5.7082 -5.1121,-12.919 -5.0019,-19.088 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4262",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 284.14,324.2 c 1.1101,-6.749 1.7937,-13.908 4.2018,-20.106 0.52034,-5.2025 3.5818,-9.599 4.4487,-14.672 2.6875,-3.2749 2.4681,-7.3816 5.4555,-10.236 1.4416,-3.251 3.3717,-6.333 6.0026,-9.0028 2.058,-2.5262 5.0822,-4.4229 8.3036,-5.2088 4.6767,-2.4883 9.1451,0.82347 12.705,3.1081 2.1857,1.8832 2.777,4.743 5.4345,6.2082 0.8606,3.8855 3.9668,6.8457 4.4348,10.897 2.273,5.7587 4.0007,11.943 4.7761,18.431 1.5267,6.4936 2.5916,14.161 2.462,20.581 -1.1668,5.4145 -1.4331,11.203 -4.7833,15.73 -1.4742,2.6359 -4.2313,5.2373 -6.3215,7.3773 -5.9884,4.4778 -13.609,5.4768 -21.099,4.7217 -5.7445,-1.3549 -11.24,-2.4507 -15.967,-5.9221 -3.1022,-2.1185 -6.0432,-4.4986 -7.5032,-7.9525 -1.9028,-4.047 -3.275,-9.4067 -2.5511,-13.954 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4258",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 334.6,354.86 c 1.403,-4.1314 2.7523,-7.9758 4.7926,-11.754 1.1745,-3.0692 3.1565,-6.1331 4.7687,-9.0028 2.8038,-2.6713 4.8762,-5.428 8.1035,-6.9022 4.8643,-2.8528 10.843,-0.2333 13.506,3.9012 1.9682,2.9726 3.9406,5.9384 4.9521,9.3029 2.8131,6.4674 3.5937,13.788 4.184,21.157 1.1881,5.9733 1.569,12.642 -1.1827,18.156 -0.86818,3.2017 -2.7064,6.8156 -5.8762,8.5872 -2.58,4.9696 -10.04,6.3248 -15.554,5.7996 -5.7634,-0.50577 -10.702,-2.7707 -15.485,-5.5476 -3.8873,-3.393 -6.8301,-7.3969 -6.0888,-12.765 -2.0539,-6.1939 1.8712,-15.268 3.8808,-20.932 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4315-6",
    transform: "matrix(-0.03814216,0.00885884,-0.00885884,-0.03814216,56.970486,97.537412)",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4286-5",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 189.3,365.01 c 0.57573,-7.0728 1.2016,-14.675 3.4515,-21.457 1.1551,-4.5503 3.4106,-8.7096 6.0026,-12.454 2.4714,-3.8699 8.1778,-6.1382 12.906,-4.3126 3.2533,1.2939 6.0561,3.833 8.1035,6.7133 3.1524,3.6637 4.6858,8.384 7.0332,12.454 2.58,5.2257 4.0104,10.982 5.7317,16.449 2.455,12.109 -0.76216,23.41 -10.678,28.817 -5.7092,3.4104 -13.792,3.9326 -20.095,1.4123 -4.3846,-1.6569 -7.1757,-5.4805 -9.4207,-9.3164 -2.9209,-5.6183 -4.222,-11.606 -3.2662,-18.123 l 0.23149,-0.18287 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4282-9",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 190.17,429.23 c 1.8305,-10.761 9.095,-19.649 18.068,-25.486 8.1612,-5.6492 16.957,-10.343 24.846,-16.299 5.0561,-5.6645 7.5158,-13.066 12.016,-19.193 7.4832,-8.8846 19.856,-11.395 30.947,-11.981 14.204,-0.51947 30.236,-0.34628 41.631,9.3822 6.5878,6.4913 8.2315,16.516 15.533,22.464 6.9948,5.5855 14.891,9.5602 22.212,14.701 10.092,6.723 19.494,17.094 19.513,29.944 0.2958,10.041 -3.52,19.939 -8.4946,28.495 -5.336,8.2918 -14.886,13.359 -24.779,12.629 -10.358,0.13126 -19.625,-5.5392 -29.789,-6.2218 -10.044,2.4158 -20.507,3.8886 -30.939,3.5049 -9.943,0.68229 -19.614,-2.4005 -29.261,-3.4278 -11.993,2.088 -23.85,8.0595 -36.291,5.5099 -11.182,-2.586 -18.883,-12.441 -21.998,-23.085 -2.3944,-6.5221 -4.7622,-13.984 -3.2138,-20.936 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4268-5",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 222.31,321.2 c 0.35791,-8.8604 1.8491,-17.553 3.9066,-26.22 3.4303,-11.533 7.3346,-25.939 19.845,-30.408 11.895,-1.8783 19.499,10.821 23.57,20.379 5.7808,13.224 9.8212,27.381 11.185,41.782 0.72297,13.299 -11.116,22.493 -23.192,24.413 -11.061,3.3232 -24.427,-0.33332 -30.314,-10.858 -3.7042,-5.7082 -5.1121,-12.919 -5.0019,-19.088 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4262-4",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 284.14,324.2 c 1.1101,-6.749 1.7937,-13.908 4.2018,-20.106 0.52034,-5.2025 3.5818,-9.599 4.4487,-14.672 2.6875,-3.2749 2.4681,-7.3816 5.4555,-10.236 1.4416,-3.251 3.3717,-6.333 6.0026,-9.0028 2.058,-2.5262 5.0822,-4.4229 8.3036,-5.2088 4.6767,-2.4883 9.1451,0.82347 12.705,3.1081 2.1857,1.8832 2.777,4.743 5.4345,6.2082 0.8606,3.8855 3.9668,6.8457 4.4348,10.897 2.273,5.7587 4.0007,11.943 4.7761,18.431 1.5267,6.4936 2.5916,14.161 2.462,20.581 -1.1668,5.4145 -1.4331,11.203 -4.7833,15.73 -1.4742,2.6359 -4.2313,5.2373 -6.3215,7.3773 -5.9884,4.4778 -13.609,5.4768 -21.099,4.7217 -5.7445,-1.3549 -11.24,-2.4507 -15.967,-5.9221 -3.1022,-2.1185 -6.0432,-4.4986 -7.5032,-7.9525 -1.9028,-4.047 -3.275,-9.4067 -2.5511,-13.954 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4258-9",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 334.6,354.86 c 1.403,-4.1314 2.7523,-7.9758 4.7926,-11.754 1.1745,-3.0692 3.1565,-6.1331 4.7687,-9.0028 2.8038,-2.6713 4.8762,-5.428 8.1035,-6.9022 4.8643,-2.8528 10.843,-0.2333 13.506,3.9012 1.9682,2.9726 3.9406,5.9384 4.9521,9.3029 2.8131,6.4674 3.5937,13.788 4.184,21.157 1.1881,5.9733 1.569,12.642 -1.1827,18.156 -0.86818,3.2017 -2.7064,6.8156 -5.8762,8.5872 -2.58,4.9696 -10.04,6.3248 -15.554,5.7996 -5.7634,-0.50577 -10.702,-2.7707 -15.485,-5.5476 -3.8873,-3.393 -6.8301,-7.3969 -6.0888,-12.765 -2.0539,-6.1939 1.8712,-15.268 3.8808,-20.932 z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      fillRule: "evenodd"
    },
    id: "g83-7-375",
    transform: "matrix(0.01340725,-0.00986231,0.00986231,0.01340725,15.916546,115.6244)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3023-9-02",
    transform: "translate(269.81467,-650.62904)",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m -126.267,1038.85 c 22.737,50.44 15.792,102.75 -15.51,116.87 -31.303,14.12 -75.11,-15.31 -97.845,-65.74 -22.737,-50.43 -15.793,-102.745 15.51,-116.863 31.303,-14.114 75.108,15.317 97.845,65.733 z",
    id: "path3025-3-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 183.155,1038.85 c -22.738,50.44 -15.793,102.75 15.512,116.87 31.303,14.12 75.106,-15.31 97.846,-65.74 22.734,-50.43 15.789,-102.745 -15.513,-116.863 -31.301,-14.114 -75.108,15.317 -97.845,65.733 z",
    id: "path3027-8-87"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 6.7856,937.757 c 11.6548,54.069 -6.1108,103.763 -39.6787,111.003 -33.5654,7.23 -70.2249,-30.74 -81.8779,-84.804 -11.653,-54.068 6.112,-103.764 39.6792,-110.997 33.5669,-7.236 70.2246,30.729 81.8774,84.798 z",
    id: "path3029-0-15"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 49.2676,937.803 c -11.6446,54.068 6.1084,103.767 39.6738,110.997 33.5676,7.24 70.2256,-30.73 81.8776,-84.797 11.654,-54.069 -6.109,-103.765 -39.678,-110.998 -33.5678,-7.234 -70.225,30.729 -81.8734,84.798 z",
    id: "path3031-2-58"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m -35.2275,1118.5 c -8.1924,14.15 -46.1563,60.99 -72.4145,76.97 -26.256,15.98 -58.792,39.38 -53.332,93.11 5.457,53.74 60.575,76.74 96.8597,74.7 36.2867,-2.03 104.6993,-8.71 153.543,-1.94 48.8413,6.77 110.4863,1.64 124.9223,-49.81 14.436,-51.45 -17.85,-84.23 -43.044,-102.83 -25.193,-18.59 -67.265,-74.2 -80.2269,-99.73 -12.96,-25.52 -78.9268,-72.26 -126.3076,9.53 z",
    id: "path3033-4-56"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g4315-6-7",
    transform: "matrix(-6.9060748e-4,0.03915133,-0.03915133,-6.9060748e-4,51.058547,101.13772)",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4286-5-9",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 189.3,365.01 c 0.57573,-7.0728 1.2016,-14.675 3.4515,-21.457 1.1551,-4.5503 3.4106,-8.7096 6.0026,-12.454 2.4714,-3.8699 8.1778,-6.1382 12.906,-4.3126 3.2533,1.2939 6.0561,3.833 8.1035,6.7133 3.1524,3.6637 4.6858,8.384 7.0332,12.454 2.58,5.2257 4.0104,10.982 5.7317,16.449 2.455,12.109 -0.76216,23.41 -10.678,28.817 -5.7092,3.4104 -13.792,3.9326 -20.095,1.4123 -4.3846,-1.6569 -7.1757,-5.4805 -9.4207,-9.3164 -2.9209,-5.6183 -4.222,-11.606 -3.2662,-18.123 l 0.23149,-0.18287 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4282-9-4",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 190.17,429.23 c 1.8305,-10.761 9.095,-19.649 18.068,-25.486 8.1612,-5.6492 16.957,-10.343 24.846,-16.299 5.0561,-5.6645 7.5158,-13.066 12.016,-19.193 7.4832,-8.8846 19.856,-11.395 30.947,-11.981 14.204,-0.51947 30.236,-0.34628 41.631,9.3822 6.5878,6.4913 8.2315,16.516 15.533,22.464 6.9948,5.5855 14.891,9.5602 22.212,14.701 10.092,6.723 19.494,17.094 19.513,29.944 0.2958,10.041 -3.52,19.939 -8.4946,28.495 -5.336,8.2918 -14.886,13.359 -24.779,12.629 -10.358,0.13126 -19.625,-5.5392 -29.789,-6.2218 -10.044,2.4158 -20.507,3.8886 -30.939,3.5049 -9.943,0.68229 -19.614,-2.4005 -29.261,-3.4278 -11.993,2.088 -23.85,8.0595 -36.291,5.5099 -11.182,-2.586 -18.883,-12.441 -21.998,-23.085 -2.3944,-6.5221 -4.7622,-13.984 -3.2138,-20.936 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4268-5-1",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 222.31,321.2 c 0.35791,-8.8604 1.8491,-17.553 3.9066,-26.22 3.4303,-11.533 7.3346,-25.939 19.845,-30.408 11.895,-1.8783 19.499,10.821 23.57,20.379 5.7808,13.224 9.8212,27.381 11.185,41.782 0.72297,13.299 -11.116,22.493 -23.192,24.413 -11.061,3.3232 -24.427,-0.33332 -30.314,-10.858 -3.7042,-5.7082 -5.1121,-12.919 -5.0019,-19.088 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4262-4-6",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 284.14,324.2 c 1.1101,-6.749 1.7937,-13.908 4.2018,-20.106 0.52034,-5.2025 3.5818,-9.599 4.4487,-14.672 2.6875,-3.2749 2.4681,-7.3816 5.4555,-10.236 1.4416,-3.251 3.3717,-6.333 6.0026,-9.0028 2.058,-2.5262 5.0822,-4.4229 8.3036,-5.2088 4.6767,-2.4883 9.1451,0.82347 12.705,3.1081 2.1857,1.8832 2.777,4.743 5.4345,6.2082 0.8606,3.8855 3.9668,6.8457 4.4348,10.897 2.273,5.7587 4.0007,11.943 4.7761,18.431 1.5267,6.4936 2.5916,14.161 2.462,20.581 -1.1668,5.4145 -1.4331,11.203 -4.7833,15.73 -1.4742,2.6359 -4.2313,5.2373 -6.3215,7.3773 -5.9884,4.4778 -13.609,5.4768 -21.099,4.7217 -5.7445,-1.3549 -11.24,-2.4507 -15.967,-5.9221 -3.1022,-2.1185 -6.0432,-4.4986 -7.5032,-7.9525 -1.9028,-4.047 -3.275,-9.4067 -2.5511,-13.954 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4258-9-12",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 334.6,354.86 c 1.403,-4.1314 2.7523,-7.9758 4.7926,-11.754 1.1745,-3.0692 3.1565,-6.1331 4.7687,-9.0028 2.8038,-2.6713 4.8762,-5.428 8.1035,-6.9022 4.8643,-2.8528 10.843,-0.2333 13.506,3.9012 1.9682,2.9726 3.9406,5.9384 4.9521,9.3029 2.8131,6.4674 3.5937,13.788 4.184,21.157 1.1881,5.9733 1.569,12.642 -1.1827,18.156 -0.86818,3.2017 -2.7064,6.8156 -5.8762,8.5872 -2.58,4.9696 -10.04,6.3248 -15.554,5.7996 -5.7634,-0.50577 -10.702,-2.7707 -15.485,-5.5476 -3.8873,-3.393 -6.8301,-7.3969 -6.0888,-12.765 -2.0539,-6.1939 1.8712,-15.268 3.8808,-20.932 z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      fillRule: "evenodd"
    },
    id: "g83-7-1-8",
    transform: "matrix(0.01657236,-0.00154164,0.00154164,0.01657236,79.433553,99.663525)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3023-9-7-7",
    transform: "translate(269.81467,-650.62904)",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m -126.267,1038.85 c 22.737,50.44 15.792,102.75 -15.51,116.87 -31.303,14.12 -75.11,-15.31 -97.845,-65.74 -22.737,-50.43 -15.793,-102.745 15.51,-116.863 31.303,-14.114 75.108,15.317 97.845,65.733 z",
    id: "path3025-3-2-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 183.155,1038.85 c -22.738,50.44 -15.793,102.75 15.512,116.87 31.303,14.12 75.106,-15.31 97.846,-65.74 22.734,-50.43 15.789,-102.745 -15.513,-116.863 -31.301,-14.114 -75.108,15.317 -97.845,65.733 z",
    id: "path3027-8-3-9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 6.7856,937.757 c 11.6548,54.069 -6.1108,103.763 -39.6787,111.003 -33.5654,7.23 -70.2249,-30.74 -81.8779,-84.804 -11.653,-54.068 6.112,-103.764 39.6792,-110.997 33.5669,-7.236 70.2246,30.729 81.8774,84.798 z",
    id: "path3029-0-6-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 49.2676,937.803 c -11.6446,54.068 6.1084,103.767 39.6738,110.997 33.5676,7.24 70.2256,-30.73 81.8776,-84.797 11.654,-54.069 -6.109,-103.765 -39.678,-110.998 -33.5678,-7.234 -70.225,30.729 -81.8734,84.798 z",
    id: "path3031-2-5-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m -35.2275,1118.5 c -8.1924,14.15 -46.1563,60.99 -72.4145,76.97 -26.256,15.98 -58.792,39.38 -53.332,93.11 5.457,53.74 60.575,76.74 96.8597,74.7 36.2867,-2.03 104.6993,-8.71 153.543,-1.94 48.8413,6.77 110.4863,1.64 124.9223,-49.81 14.436,-51.45 -17.85,-84.23 -43.044,-102.83 -25.193,-18.59 -67.265,-74.2 -80.2269,-99.73 -12.96,-25.52 -78.9268,-72.26 -126.3076,9.53 z",
    id: "path3033-4-5-1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      fillRule: "evenodd"
    },
    id: "g83-7-375-4",
    transform: "matrix(0.01340725,-0.00986231,0.00986231,0.01340725,80.369694,118.03633)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3023-9-02-9",
    transform: "translate(269.81467,-650.62904)",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m -126.267,1038.85 c 22.737,50.44 15.792,102.75 -15.51,116.87 -31.303,14.12 -75.11,-15.31 -97.845,-65.74 -22.737,-50.43 -15.793,-102.745 15.51,-116.863 31.303,-14.114 75.108,15.317 97.845,65.733 z",
    id: "path3025-3-1-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 183.155,1038.85 c -22.738,50.44 -15.793,102.75 15.512,116.87 31.303,14.12 75.106,-15.31 97.846,-65.74 22.734,-50.43 15.789,-102.745 -15.513,-116.863 -31.301,-14.114 -75.108,15.317 -97.845,65.733 z",
    id: "path3027-8-87-9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 6.7856,937.757 c 11.6548,54.069 -6.1108,103.763 -39.6787,111.003 -33.5654,7.23 -70.2249,-30.74 -81.8779,-84.804 -11.653,-54.068 6.112,-103.764 39.6792,-110.997 33.5669,-7.236 70.2246,30.729 81.8774,84.798 z",
    id: "path3029-0-15-0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 49.2676,937.803 c -11.6446,54.068 6.1084,103.767 39.6738,110.997 33.5676,7.24 70.2256,-30.73 81.8776,-84.797 11.654,-54.069 -6.109,-103.765 -39.678,-110.998 -33.5678,-7.234 -70.225,30.729 -81.8734,84.798 z",
    id: "path3031-2-58-9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m -35.2275,1118.5 c -8.1924,14.15 -46.1563,60.99 -72.4145,76.97 -26.256,15.98 -58.792,39.38 -53.332,93.11 5.457,53.74 60.575,76.74 96.8597,74.7 36.2867,-2.03 104.6993,-8.71 153.543,-1.94 48.8413,6.77 110.4863,1.64 124.9223,-49.81 14.436,-51.45 -17.85,-84.23 -43.044,-102.83 -25.193,-18.59 -67.265,-74.2 -80.2269,-99.73 -12.96,-25.52 -78.9268,-72.26 -126.3076,9.53 z",
    id: "path3033-4-56-3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g4315-6-7-4",
    transform: "matrix(-6.9060748e-4,0.03915133,-0.03915133,-6.9060748e-4,115.5117,103.54966)",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4286-5-9-0",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 189.3,365.01 c 0.57573,-7.0728 1.2016,-14.675 3.4515,-21.457 1.1551,-4.5503 3.4106,-8.7096 6.0026,-12.454 2.4714,-3.8699 8.1778,-6.1382 12.906,-4.3126 3.2533,1.2939 6.0561,3.833 8.1035,6.7133 3.1524,3.6637 4.6858,8.384 7.0332,12.454 2.58,5.2257 4.0104,10.982 5.7317,16.449 2.455,12.109 -0.76216,23.41 -10.678,28.817 -5.7092,3.4104 -13.792,3.9326 -20.095,1.4123 -4.3846,-1.6569 -7.1757,-5.4805 -9.4207,-9.3164 -2.9209,-5.6183 -4.222,-11.606 -3.2662,-18.123 l 0.23149,-0.18287 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4282-9-4-7",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 190.17,429.23 c 1.8305,-10.761 9.095,-19.649 18.068,-25.486 8.1612,-5.6492 16.957,-10.343 24.846,-16.299 5.0561,-5.6645 7.5158,-13.066 12.016,-19.193 7.4832,-8.8846 19.856,-11.395 30.947,-11.981 14.204,-0.51947 30.236,-0.34628 41.631,9.3822 6.5878,6.4913 8.2315,16.516 15.533,22.464 6.9948,5.5855 14.891,9.5602 22.212,14.701 10.092,6.723 19.494,17.094 19.513,29.944 0.2958,10.041 -3.52,19.939 -8.4946,28.495 -5.336,8.2918 -14.886,13.359 -24.779,12.629 -10.358,0.13126 -19.625,-5.5392 -29.789,-6.2218 -10.044,2.4158 -20.507,3.8886 -30.939,3.5049 -9.943,0.68229 -19.614,-2.4005 -29.261,-3.4278 -11.993,2.088 -23.85,8.0595 -36.291,5.5099 -11.182,-2.586 -18.883,-12.441 -21.998,-23.085 -2.3944,-6.5221 -4.7622,-13.984 -3.2138,-20.936 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4268-5-1-5",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 222.31,321.2 c 0.35791,-8.8604 1.8491,-17.553 3.9066,-26.22 3.4303,-11.533 7.3346,-25.939 19.845,-30.408 11.895,-1.8783 19.499,10.821 23.57,20.379 5.7808,13.224 9.8212,27.381 11.185,41.782 0.72297,13.299 -11.116,22.493 -23.192,24.413 -11.061,3.3232 -24.427,-0.33332 -30.314,-10.858 -3.7042,-5.7082 -5.1121,-12.919 -5.0019,-19.088 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4262-4-6-7",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 284.14,324.2 c 1.1101,-6.749 1.7937,-13.908 4.2018,-20.106 0.52034,-5.2025 3.5818,-9.599 4.4487,-14.672 2.6875,-3.2749 2.4681,-7.3816 5.4555,-10.236 1.4416,-3.251 3.3717,-6.333 6.0026,-9.0028 2.058,-2.5262 5.0822,-4.4229 8.3036,-5.2088 4.6767,-2.4883 9.1451,0.82347 12.705,3.1081 2.1857,1.8832 2.777,4.743 5.4345,6.2082 0.8606,3.8855 3.9668,6.8457 4.4348,10.897 2.273,5.7587 4.0007,11.943 4.7761,18.431 1.5267,6.4936 2.5916,14.161 2.462,20.581 -1.1668,5.4145 -1.4331,11.203 -4.7833,15.73 -1.4742,2.6359 -4.2313,5.2373 -6.3215,7.3773 -5.9884,4.4778 -13.609,5.4768 -21.099,4.7217 -5.7445,-1.3549 -11.24,-2.4507 -15.967,-5.9221 -3.1022,-2.1185 -6.0432,-4.4986 -7.5032,-7.9525 -1.9028,-4.047 -3.275,-9.4067 -2.5511,-13.954 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4258-9-12-5",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 334.6,354.86 c 1.403,-4.1314 2.7523,-7.9758 4.7926,-11.754 1.1745,-3.0692 3.1565,-6.1331 4.7687,-9.0028 2.8038,-2.6713 4.8762,-5.428 8.1035,-6.9022 4.8643,-2.8528 10.843,-0.2333 13.506,3.9012 1.9682,2.9726 3.9406,5.9384 4.9521,9.3029 2.8131,6.4674 3.5937,13.788 4.184,21.157 1.1881,5.9733 1.569,12.642 -1.1827,18.156 -0.86818,3.2017 -2.7064,6.8156 -5.8762,8.5872 -2.58,4.9696 -10.04,6.3248 -15.554,5.7996 -5.7634,-0.50577 -10.702,-2.7707 -15.485,-5.5476 -3.8873,-3.393 -6.8301,-7.3969 -6.0888,-12.765 -2.0539,-6.1939 1.8712,-15.268 3.8808,-20.932 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4315-1",
    transform: "matrix(-0.03876891,-0.0055023,0.0055023,-0.03876891,81.506648,66.89529)",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4286-7",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 189.3,365.01 c 0.57573,-7.0728 1.2016,-14.675 3.4515,-21.457 1.1551,-4.5503 3.4106,-8.7096 6.0026,-12.454 2.4714,-3.8699 8.1778,-6.1382 12.906,-4.3126 3.2533,1.2939 6.0561,3.833 8.1035,6.7133 3.1524,3.6637 4.6858,8.384 7.0332,12.454 2.58,5.2257 4.0104,10.982 5.7317,16.449 2.455,12.109 -0.76216,23.41 -10.678,28.817 -5.7092,3.4104 -13.792,3.9326 -20.095,1.4123 -4.3846,-1.6569 -7.1757,-5.4805 -9.4207,-9.3164 -2.9209,-5.6183 -4.222,-11.606 -3.2662,-18.123 l 0.23149,-0.18287 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4282-5",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 190.17,429.23 c 1.8305,-10.761 9.095,-19.649 18.068,-25.486 8.1612,-5.6492 16.957,-10.343 24.846,-16.299 5.0561,-5.6645 7.5158,-13.066 12.016,-19.193 7.4832,-8.8846 19.856,-11.395 30.947,-11.981 14.204,-0.51947 30.236,-0.34628 41.631,9.3822 6.5878,6.4913 8.2315,16.516 15.533,22.464 6.9948,5.5855 14.891,9.5602 22.212,14.701 10.092,6.723 19.494,17.094 19.513,29.944 0.2958,10.041 -3.52,19.939 -8.4946,28.495 -5.336,8.2918 -14.886,13.359 -24.779,12.629 -10.358,0.13126 -19.625,-5.5392 -29.789,-6.2218 -10.044,2.4158 -20.507,3.8886 -30.939,3.5049 -9.943,0.68229 -19.614,-2.4005 -29.261,-3.4278 -11.993,2.088 -23.85,8.0595 -36.291,5.5099 -11.182,-2.586 -18.883,-12.441 -21.998,-23.085 -2.3944,-6.5221 -4.7622,-13.984 -3.2138,-20.936 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4268-54",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 222.31,321.2 c 0.35791,-8.8604 1.8491,-17.553 3.9066,-26.22 3.4303,-11.533 7.3346,-25.939 19.845,-30.408 11.895,-1.8783 19.499,10.821 23.57,20.379 5.7808,13.224 9.8212,27.381 11.185,41.782 0.72297,13.299 -11.116,22.493 -23.192,24.413 -11.061,3.3232 -24.427,-0.33332 -30.314,-10.858 -3.7042,-5.7082 -5.1121,-12.919 -5.0019,-19.088 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4262-1",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 284.14,324.2 c 1.1101,-6.749 1.7937,-13.908 4.2018,-20.106 0.52034,-5.2025 3.5818,-9.599 4.4487,-14.672 2.6875,-3.2749 2.4681,-7.3816 5.4555,-10.236 1.4416,-3.251 3.3717,-6.333 6.0026,-9.0028 2.058,-2.5262 5.0822,-4.4229 8.3036,-5.2088 4.6767,-2.4883 9.1451,0.82347 12.705,3.1081 2.1857,1.8832 2.777,4.743 5.4345,6.2082 0.8606,3.8855 3.9668,6.8457 4.4348,10.897 2.273,5.7587 4.0007,11.943 4.7761,18.431 1.5267,6.4936 2.5916,14.161 2.462,20.581 -1.1668,5.4145 -1.4331,11.203 -4.7833,15.73 -1.4742,2.6359 -4.2313,5.2373 -6.3215,7.3773 -5.9884,4.4778 -13.609,5.4768 -21.099,4.7217 -5.7445,-1.3549 -11.24,-2.4507 -15.967,-5.9221 -3.1022,-2.1185 -6.0432,-4.4986 -7.5032,-7.9525 -1.9028,-4.047 -3.275,-9.4067 -2.5511,-13.954 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4258-8",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 334.6,354.86 c 1.403,-4.1314 2.7523,-7.9758 4.7926,-11.754 1.1745,-3.0692 3.1565,-6.1331 4.7687,-9.0028 2.8038,-2.6713 4.8762,-5.428 8.1035,-6.9022 4.8643,-2.8528 10.843,-0.2333 13.506,3.9012 1.9682,2.9726 3.9406,5.9384 4.9521,9.3029 2.8131,6.4674 3.5937,13.788 4.184,21.157 1.1881,5.9733 1.569,12.642 -1.1827,18.156 -0.86818,3.2017 -2.7064,6.8156 -5.8762,8.5872 -2.58,4.9696 -10.04,6.3248 -15.554,5.7996 -5.7634,-0.50577 -10.702,-2.7707 -15.485,-5.5476 -3.8873,-3.393 -6.8301,-7.3969 -6.0888,-12.765 -2.0539,-6.1939 1.8712,-15.268 3.8808,-20.932 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4315-8",
    transform: "matrix(0.02980479,-0.02539642,0.02539642,0.02980479,1.329196,34.143887)",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4286-3",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 189.3,365.01 c 0.57573,-7.0728 1.2016,-14.675 3.4515,-21.457 1.1551,-4.5503 3.4106,-8.7096 6.0026,-12.454 2.4714,-3.8699 8.1778,-6.1382 12.906,-4.3126 3.2533,1.2939 6.0561,3.833 8.1035,6.7133 3.1524,3.6637 4.6858,8.384 7.0332,12.454 2.58,5.2257 4.0104,10.982 5.7317,16.449 2.455,12.109 -0.76216,23.41 -10.678,28.817 -5.7092,3.4104 -13.792,3.9326 -20.095,1.4123 -4.3846,-1.6569 -7.1757,-5.4805 -9.4207,-9.3164 -2.9209,-5.6183 -4.222,-11.606 -3.2662,-18.123 l 0.23149,-0.18287 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4282-52",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 190.17,429.23 c 1.8305,-10.761 9.095,-19.649 18.068,-25.486 8.1612,-5.6492 16.957,-10.343 24.846,-16.299 5.0561,-5.6645 7.5158,-13.066 12.016,-19.193 7.4832,-8.8846 19.856,-11.395 30.947,-11.981 14.204,-0.51947 30.236,-0.34628 41.631,9.3822 6.5878,6.4913 8.2315,16.516 15.533,22.464 6.9948,5.5855 14.891,9.5602 22.212,14.701 10.092,6.723 19.494,17.094 19.513,29.944 0.2958,10.041 -3.52,19.939 -8.4946,28.495 -5.336,8.2918 -14.886,13.359 -24.779,12.629 -10.358,0.13126 -19.625,-5.5392 -29.789,-6.2218 -10.044,2.4158 -20.507,3.8886 -30.939,3.5049 -9.943,0.68229 -19.614,-2.4005 -29.261,-3.4278 -11.993,2.088 -23.85,8.0595 -36.291,5.5099 -11.182,-2.586 -18.883,-12.441 -21.998,-23.085 -2.3944,-6.5221 -4.7622,-13.984 -3.2138,-20.936 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4268-2",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 222.31,321.2 c 0.35791,-8.8604 1.8491,-17.553 3.9066,-26.22 3.4303,-11.533 7.3346,-25.939 19.845,-30.408 11.895,-1.8783 19.499,10.821 23.57,20.379 5.7808,13.224 9.8212,27.381 11.185,41.782 0.72297,13.299 -11.116,22.493 -23.192,24.413 -11.061,3.3232 -24.427,-0.33332 -30.314,-10.858 -3.7042,-5.7082 -5.1121,-12.919 -5.0019,-19.088 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4262-6",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 284.14,324.2 c 1.1101,-6.749 1.7937,-13.908 4.2018,-20.106 0.52034,-5.2025 3.5818,-9.599 4.4487,-14.672 2.6875,-3.2749 2.4681,-7.3816 5.4555,-10.236 1.4416,-3.251 3.3717,-6.333 6.0026,-9.0028 2.058,-2.5262 5.0822,-4.4229 8.3036,-5.2088 4.6767,-2.4883 9.1451,0.82347 12.705,3.1081 2.1857,1.8832 2.777,4.743 5.4345,6.2082 0.8606,3.8855 3.9668,6.8457 4.4348,10.897 2.273,5.7587 4.0007,11.943 4.7761,18.431 1.5267,6.4936 2.5916,14.161 2.462,20.581 -1.1668,5.4145 -1.4331,11.203 -4.7833,15.73 -1.4742,2.6359 -4.2313,5.2373 -6.3215,7.3773 -5.9884,4.4778 -13.609,5.4768 -21.099,4.7217 -5.7445,-1.3549 -11.24,-2.4507 -15.967,-5.9221 -3.1022,-2.1185 -6.0432,-4.4986 -7.5032,-7.9525 -1.9028,-4.047 -3.275,-9.4067 -2.5511,-13.954 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4258-6",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 334.6,354.86 c 1.403,-4.1314 2.7523,-7.9758 4.7926,-11.754 1.1745,-3.0692 3.1565,-6.1331 4.7687,-9.0028 2.8038,-2.6713 4.8762,-5.428 8.1035,-6.9022 4.8643,-2.8528 10.843,-0.2333 13.506,3.9012 1.9682,2.9726 3.9406,5.9384 4.9521,9.3029 2.8131,6.4674 3.5937,13.788 4.184,21.157 1.1881,5.9733 1.569,12.642 -1.1827,18.156 -0.86818,3.2017 -2.7064,6.8156 -5.8762,8.5872 -2.58,4.9696 -10.04,6.3248 -15.554,5.7996 -5.7634,-0.50577 -10.702,-2.7707 -15.485,-5.5476 -3.8873,-3.393 -6.8301,-7.3969 -6.0888,-12.765 -2.0539,-6.1939 1.8712,-15.268 3.8808,-20.932 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4315-7",
    transform: "matrix(-0.03892006,0.00430495,-0.00430495,-0.03892006,113.25861,51.140319)",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4286-8",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 189.3,365.01 c 0.57573,-7.0728 1.2016,-14.675 3.4515,-21.457 1.1551,-4.5503 3.4106,-8.7096 6.0026,-12.454 2.4714,-3.8699 8.1778,-6.1382 12.906,-4.3126 3.2533,1.2939 6.0561,3.833 8.1035,6.7133 3.1524,3.6637 4.6858,8.384 7.0332,12.454 2.58,5.2257 4.0104,10.982 5.7317,16.449 2.455,12.109 -0.76216,23.41 -10.678,28.817 -5.7092,3.4104 -13.792,3.9326 -20.095,1.4123 -4.3846,-1.6569 -7.1757,-5.4805 -9.4207,-9.3164 -2.9209,-5.6183 -4.222,-11.606 -3.2662,-18.123 l 0.23149,-0.18287 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4282-4",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 190.17,429.23 c 1.8305,-10.761 9.095,-19.649 18.068,-25.486 8.1612,-5.6492 16.957,-10.343 24.846,-16.299 5.0561,-5.6645 7.5158,-13.066 12.016,-19.193 7.4832,-8.8846 19.856,-11.395 30.947,-11.981 14.204,-0.51947 30.236,-0.34628 41.631,9.3822 6.5878,6.4913 8.2315,16.516 15.533,22.464 6.9948,5.5855 14.891,9.5602 22.212,14.701 10.092,6.723 19.494,17.094 19.513,29.944 0.2958,10.041 -3.52,19.939 -8.4946,28.495 -5.336,8.2918 -14.886,13.359 -24.779,12.629 -10.358,0.13126 -19.625,-5.5392 -29.789,-6.2218 -10.044,2.4158 -20.507,3.8886 -30.939,3.5049 -9.943,0.68229 -19.614,-2.4005 -29.261,-3.4278 -11.993,2.088 -23.85,8.0595 -36.291,5.5099 -11.182,-2.586 -18.883,-12.441 -21.998,-23.085 -2.3944,-6.5221 -4.7622,-13.984 -3.2138,-20.936 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4268-1",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 222.31,321.2 c 0.35791,-8.8604 1.8491,-17.553 3.9066,-26.22 3.4303,-11.533 7.3346,-25.939 19.845,-30.408 11.895,-1.8783 19.499,10.821 23.57,20.379 5.7808,13.224 9.8212,27.381 11.185,41.782 0.72297,13.299 -11.116,22.493 -23.192,24.413 -11.061,3.3232 -24.427,-0.33332 -30.314,-10.858 -3.7042,-5.7082 -5.1121,-12.919 -5.0019,-19.088 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4262-7",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 284.14,324.2 c 1.1101,-6.749 1.7937,-13.908 4.2018,-20.106 0.52034,-5.2025 3.5818,-9.599 4.4487,-14.672 2.6875,-3.2749 2.4681,-7.3816 5.4555,-10.236 1.4416,-3.251 3.3717,-6.333 6.0026,-9.0028 2.058,-2.5262 5.0822,-4.4229 8.3036,-5.2088 4.6767,-2.4883 9.1451,0.82347 12.705,3.1081 2.1857,1.8832 2.777,4.743 5.4345,6.2082 0.8606,3.8855 3.9668,6.8457 4.4348,10.897 2.273,5.7587 4.0007,11.943 4.7761,18.431 1.5267,6.4936 2.5916,14.161 2.462,20.581 -1.1668,5.4145 -1.4331,11.203 -4.7833,15.73 -1.4742,2.6359 -4.2313,5.2373 -6.3215,7.3773 -5.9884,4.4778 -13.609,5.4768 -21.099,4.7217 -5.7445,-1.3549 -11.24,-2.4507 -15.967,-5.9221 -3.1022,-2.1185 -6.0432,-4.4986 -7.5032,-7.9525 -1.9028,-4.047 -3.275,-9.4067 -2.5511,-13.954 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4258-1",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 334.6,354.86 c 1.403,-4.1314 2.7523,-7.9758 4.7926,-11.754 1.1745,-3.0692 3.1565,-6.1331 4.7687,-9.0028 2.8038,-2.6713 4.8762,-5.428 8.1035,-6.9022 4.8643,-2.8528 10.843,-0.2333 13.506,3.9012 1.9682,2.9726 3.9406,5.9384 4.9521,9.3029 2.8131,6.4674 3.5937,13.788 4.184,21.157 1.1881,5.9733 1.569,12.642 -1.1827,18.156 -0.86818,3.2017 -2.7064,6.8156 -5.8762,8.5872 -2.58,4.9696 -10.04,6.3248 -15.554,5.7996 -5.7634,-0.50577 -10.702,-2.7707 -15.485,-5.5476 -3.8873,-3.393 -6.8301,-7.3969 -6.0888,-12.765 -2.0539,-6.1939 1.8712,-15.268 3.8808,-20.932 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4315-87",
    transform: "matrix(-0.02542031,-0.02978442,0.02978442,-0.02542031,43.149686,74.148693)",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4286-87",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 189.3,365.01 c 0.57573,-7.0728 1.2016,-14.675 3.4515,-21.457 1.1551,-4.5503 3.4106,-8.7096 6.0026,-12.454 2.4714,-3.8699 8.1778,-6.1382 12.906,-4.3126 3.2533,1.2939 6.0561,3.833 8.1035,6.7133 3.1524,3.6637 4.6858,8.384 7.0332,12.454 2.58,5.2257 4.0104,10.982 5.7317,16.449 2.455,12.109 -0.76216,23.41 -10.678,28.817 -5.7092,3.4104 -13.792,3.9326 -20.095,1.4123 -4.3846,-1.6569 -7.1757,-5.4805 -9.4207,-9.3164 -2.9209,-5.6183 -4.222,-11.606 -3.2662,-18.123 l 0.23149,-0.18287 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4282-7",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 190.17,429.23 c 1.8305,-10.761 9.095,-19.649 18.068,-25.486 8.1612,-5.6492 16.957,-10.343 24.846,-16.299 5.0561,-5.6645 7.5158,-13.066 12.016,-19.193 7.4832,-8.8846 19.856,-11.395 30.947,-11.981 14.204,-0.51947 30.236,-0.34628 41.631,9.3822 6.5878,6.4913 8.2315,16.516 15.533,22.464 6.9948,5.5855 14.891,9.5602 22.212,14.701 10.092,6.723 19.494,17.094 19.513,29.944 0.2958,10.041 -3.52,19.939 -8.4946,28.495 -5.336,8.2918 -14.886,13.359 -24.779,12.629 -10.358,0.13126 -19.625,-5.5392 -29.789,-6.2218 -10.044,2.4158 -20.507,3.8886 -30.939,3.5049 -9.943,0.68229 -19.614,-2.4005 -29.261,-3.4278 -11.993,2.088 -23.85,8.0595 -36.291,5.5099 -11.182,-2.586 -18.883,-12.441 -21.998,-23.085 -2.3944,-6.5221 -4.7622,-13.984 -3.2138,-20.936 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4268-4",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 222.31,321.2 c 0.35791,-8.8604 1.8491,-17.553 3.9066,-26.22 3.4303,-11.533 7.3346,-25.939 19.845,-30.408 11.895,-1.8783 19.499,10.821 23.57,20.379 5.7808,13.224 9.8212,27.381 11.185,41.782 0.72297,13.299 -11.116,22.493 -23.192,24.413 -11.061,3.3232 -24.427,-0.33332 -30.314,-10.858 -3.7042,-5.7082 -5.1121,-12.919 -5.0019,-19.088 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4262-49",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 284.14,324.2 c 1.1101,-6.749 1.7937,-13.908 4.2018,-20.106 0.52034,-5.2025 3.5818,-9.599 4.4487,-14.672 2.6875,-3.2749 2.4681,-7.3816 5.4555,-10.236 1.4416,-3.251 3.3717,-6.333 6.0026,-9.0028 2.058,-2.5262 5.0822,-4.4229 8.3036,-5.2088 4.6767,-2.4883 9.1451,0.82347 12.705,3.1081 2.1857,1.8832 2.777,4.743 5.4345,6.2082 0.8606,3.8855 3.9668,6.8457 4.4348,10.897 2.273,5.7587 4.0007,11.943 4.7761,18.431 1.5267,6.4936 2.5916,14.161 2.462,20.581 -1.1668,5.4145 -1.4331,11.203 -4.7833,15.73 -1.4742,2.6359 -4.2313,5.2373 -6.3215,7.3773 -5.9884,4.4778 -13.609,5.4768 -21.099,4.7217 -5.7445,-1.3549 -11.24,-2.4507 -15.967,-5.9221 -3.1022,-2.1185 -6.0432,-4.4986 -7.5032,-7.9525 -1.9028,-4.047 -3.275,-9.4067 -2.5511,-13.954 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4258-15",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 334.6,354.86 c 1.403,-4.1314 2.7523,-7.9758 4.7926,-11.754 1.1745,-3.0692 3.1565,-6.1331 4.7687,-9.0028 2.8038,-2.6713 4.8762,-5.428 8.1035,-6.9022 4.8643,-2.8528 10.843,-0.2333 13.506,3.9012 1.9682,2.9726 3.9406,5.9384 4.9521,9.3029 2.8131,6.4674 3.5937,13.788 4.184,21.157 1.1881,5.9733 1.569,12.642 -1.1827,18.156 -0.86818,3.2017 -2.7064,6.8156 -5.8762,8.5872 -2.58,4.9696 -10.04,6.3248 -15.554,5.7996 -5.7634,-0.50577 -10.702,-2.7707 -15.485,-5.5476 -3.8873,-3.393 -6.8301,-7.3969 -6.0888,-12.765 -2.0539,-6.1939 1.8712,-15.268 3.8808,-20.932 z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      fillRule: "evenodd"
    },
    id: "g83-7-3-0",
    transform: "matrix(-0.01609312,0.00424627,-0.00424627,-0.01609312,56.926615,72.138466)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3023-9-9-4",
    transform: "translate(269.81467,-650.62904)",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m -126.267,1038.85 c 22.737,50.44 15.792,102.75 -15.51,116.87 -31.303,14.12 -75.11,-15.31 -97.845,-65.74 -22.737,-50.43 -15.793,-102.745 15.51,-116.863 31.303,-14.114 75.108,15.317 97.845,65.733 z",
    id: "path3025-3-9-4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 183.155,1038.85 c -22.738,50.44 -15.793,102.75 15.512,116.87 31.303,14.12 75.106,-15.31 97.846,-65.74 22.734,-50.43 15.789,-102.745 -15.513,-116.863 -31.301,-14.114 -75.108,15.317 -97.845,65.733 z",
    id: "path3027-8-7-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 6.7856,937.757 c 11.6548,54.069 -6.1108,103.763 -39.6787,111.003 -33.5654,7.23 -70.2249,-30.74 -81.8779,-84.804 -11.653,-54.068 6.112,-103.764 39.6792,-110.997 33.5669,-7.236 70.2246,30.729 81.8774,84.798 z",
    id: "path3029-0-0-9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 49.2676,937.803 c -11.6446,54.068 6.1084,103.767 39.6738,110.997 33.5676,7.24 70.2256,-30.73 81.8776,-84.797 11.654,-54.069 -6.109,-103.765 -39.678,-110.998 -33.5678,-7.234 -70.225,30.729 -81.8734,84.798 z",
    id: "path3031-2-3-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m -35.2275,1118.5 c -8.1924,14.15 -46.1563,60.99 -72.4145,76.97 -26.256,15.98 -58.792,39.38 -53.332,93.11 5.457,53.74 60.575,76.74 96.8597,74.7 36.2867,-2.03 104.6993,-8.71 153.543,-1.94 48.8413,6.77 110.4863,1.64 124.9223,-49.81 14.436,-51.45 -17.85,-84.23 -43.044,-102.83 -25.193,-18.59 -67.265,-74.2 -80.2269,-99.73 -12.96,-25.52 -78.9268,-72.26 -126.3076,9.53 z",
    id: "path3033-4-9-5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g4315-8-3",
    transform: "matrix(0.00695734,0.03853439,-0.03853439,0.00695734,70.194105,37.998566)",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4286-3-9",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 189.3,365.01 c 0.57573,-7.0728 1.2016,-14.675 3.4515,-21.457 1.1551,-4.5503 3.4106,-8.7096 6.0026,-12.454 2.4714,-3.8699 8.1778,-6.1382 12.906,-4.3126 3.2533,1.2939 6.0561,3.833 8.1035,6.7133 3.1524,3.6637 4.6858,8.384 7.0332,12.454 2.58,5.2257 4.0104,10.982 5.7317,16.449 2.455,12.109 -0.76216,23.41 -10.678,28.817 -5.7092,3.4104 -13.792,3.9326 -20.095,1.4123 -4.3846,-1.6569 -7.1757,-5.4805 -9.4207,-9.3164 -2.9209,-5.6183 -4.222,-11.606 -3.2662,-18.123 l 0.23149,-0.18287 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4282-52-0",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 190.17,429.23 c 1.8305,-10.761 9.095,-19.649 18.068,-25.486 8.1612,-5.6492 16.957,-10.343 24.846,-16.299 5.0561,-5.6645 7.5158,-13.066 12.016,-19.193 7.4832,-8.8846 19.856,-11.395 30.947,-11.981 14.204,-0.51947 30.236,-0.34628 41.631,9.3822 6.5878,6.4913 8.2315,16.516 15.533,22.464 6.9948,5.5855 14.891,9.5602 22.212,14.701 10.092,6.723 19.494,17.094 19.513,29.944 0.2958,10.041 -3.52,19.939 -8.4946,28.495 -5.336,8.2918 -14.886,13.359 -24.779,12.629 -10.358,0.13126 -19.625,-5.5392 -29.789,-6.2218 -10.044,2.4158 -20.507,3.8886 -30.939,3.5049 -9.943,0.68229 -19.614,-2.4005 -29.261,-3.4278 -11.993,2.088 -23.85,8.0595 -36.291,5.5099 -11.182,-2.586 -18.883,-12.441 -21.998,-23.085 -2.3944,-6.5221 -4.7622,-13.984 -3.2138,-20.936 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4268-2-55",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 222.31,321.2 c 0.35791,-8.8604 1.8491,-17.553 3.9066,-26.22 3.4303,-11.533 7.3346,-25.939 19.845,-30.408 11.895,-1.8783 19.499,10.821 23.57,20.379 5.7808,13.224 9.8212,27.381 11.185,41.782 0.72297,13.299 -11.116,22.493 -23.192,24.413 -11.061,3.3232 -24.427,-0.33332 -30.314,-10.858 -3.7042,-5.7082 -5.1121,-12.919 -5.0019,-19.088 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4262-6-6",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 284.14,324.2 c 1.1101,-6.749 1.7937,-13.908 4.2018,-20.106 0.52034,-5.2025 3.5818,-9.599 4.4487,-14.672 2.6875,-3.2749 2.4681,-7.3816 5.4555,-10.236 1.4416,-3.251 3.3717,-6.333 6.0026,-9.0028 2.058,-2.5262 5.0822,-4.4229 8.3036,-5.2088 4.6767,-2.4883 9.1451,0.82347 12.705,3.1081 2.1857,1.8832 2.777,4.743 5.4345,6.2082 0.8606,3.8855 3.9668,6.8457 4.4348,10.897 2.273,5.7587 4.0007,11.943 4.7761,18.431 1.5267,6.4936 2.5916,14.161 2.462,20.581 -1.1668,5.4145 -1.4331,11.203 -4.7833,15.73 -1.4742,2.6359 -4.2313,5.2373 -6.3215,7.3773 -5.9884,4.4778 -13.609,5.4768 -21.099,4.7217 -5.7445,-1.3549 -11.24,-2.4507 -15.967,-5.9221 -3.1022,-2.1185 -6.0432,-4.4986 -7.5032,-7.9525 -1.9028,-4.047 -3.275,-9.4067 -2.5511,-13.954 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4258-6-3",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 334.6,354.86 c 1.403,-4.1314 2.7523,-7.9758 4.7926,-11.754 1.1745,-3.0692 3.1565,-6.1331 4.7687,-9.0028 2.8038,-2.6713 4.8762,-5.428 8.1035,-6.9022 4.8643,-2.8528 10.843,-0.2333 13.506,3.9012 1.9682,2.9726 3.9406,5.9384 4.9521,9.3029 2.8131,6.4674 3.5937,13.788 4.184,21.157 1.1881,5.9733 1.569,12.642 -1.1827,18.156 -0.86818,3.2017 -2.7064,6.8156 -5.8762,8.5872 -2.58,4.9696 -10.04,6.3248 -15.554,5.7996 -5.7634,-0.50577 -10.702,-2.7707 -15.485,-5.5476 -3.8873,-3.393 -6.8301,-7.3969 -6.0888,-12.765 -2.0539,-6.1939 1.8712,-15.268 3.8808,-20.932 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4315-87-26",
    transform: "matrix(0.0385288,-0.00698823,0.00698823,0.0385288,14.582529,54.020117)",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4286-87-8",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 189.3,365.01 c 0.57573,-7.0728 1.2016,-14.675 3.4515,-21.457 1.1551,-4.5503 3.4106,-8.7096 6.0026,-12.454 2.4714,-3.8699 8.1778,-6.1382 12.906,-4.3126 3.2533,1.2939 6.0561,3.833 8.1035,6.7133 3.1524,3.6637 4.6858,8.384 7.0332,12.454 2.58,5.2257 4.0104,10.982 5.7317,16.449 2.455,12.109 -0.76216,23.41 -10.678,28.817 -5.7092,3.4104 -13.792,3.9326 -20.095,1.4123 -4.3846,-1.6569 -7.1757,-5.4805 -9.4207,-9.3164 -2.9209,-5.6183 -4.222,-11.606 -3.2662,-18.123 l 0.23149,-0.18287 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4282-7-9",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 190.17,429.23 c 1.8305,-10.761 9.095,-19.649 18.068,-25.486 8.1612,-5.6492 16.957,-10.343 24.846,-16.299 5.0561,-5.6645 7.5158,-13.066 12.016,-19.193 7.4832,-8.8846 19.856,-11.395 30.947,-11.981 14.204,-0.51947 30.236,-0.34628 41.631,9.3822 6.5878,6.4913 8.2315,16.516 15.533,22.464 6.9948,5.5855 14.891,9.5602 22.212,14.701 10.092,6.723 19.494,17.094 19.513,29.944 0.2958,10.041 -3.52,19.939 -8.4946,28.495 -5.336,8.2918 -14.886,13.359 -24.779,12.629 -10.358,0.13126 -19.625,-5.5392 -29.789,-6.2218 -10.044,2.4158 -20.507,3.8886 -30.939,3.5049 -9.943,0.68229 -19.614,-2.4005 -29.261,-3.4278 -11.993,2.088 -23.85,8.0595 -36.291,5.5099 -11.182,-2.586 -18.883,-12.441 -21.998,-23.085 -2.3944,-6.5221 -4.7622,-13.984 -3.2138,-20.936 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4268-4-1",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 222.31,321.2 c 0.35791,-8.8604 1.8491,-17.553 3.9066,-26.22 3.4303,-11.533 7.3346,-25.939 19.845,-30.408 11.895,-1.8783 19.499,10.821 23.57,20.379 5.7808,13.224 9.8212,27.381 11.185,41.782 0.72297,13.299 -11.116,22.493 -23.192,24.413 -11.061,3.3232 -24.427,-0.33332 -30.314,-10.858 -3.7042,-5.7082 -5.1121,-12.919 -5.0019,-19.088 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4262-49-4",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 284.14,324.2 c 1.1101,-6.749 1.7937,-13.908 4.2018,-20.106 0.52034,-5.2025 3.5818,-9.599 4.4487,-14.672 2.6875,-3.2749 2.4681,-7.3816 5.4555,-10.236 1.4416,-3.251 3.3717,-6.333 6.0026,-9.0028 2.058,-2.5262 5.0822,-4.4229 8.3036,-5.2088 4.6767,-2.4883 9.1451,0.82347 12.705,3.1081 2.1857,1.8832 2.777,4.743 5.4345,6.2082 0.8606,3.8855 3.9668,6.8457 4.4348,10.897 2.273,5.7587 4.0007,11.943 4.7761,18.431 1.5267,6.4936 2.5916,14.161 2.462,20.581 -1.1668,5.4145 -1.4331,11.203 -4.7833,15.73 -1.4742,2.6359 -4.2313,5.2373 -6.3215,7.3773 -5.9884,4.4778 -13.609,5.4768 -21.099,4.7217 -5.7445,-1.3549 -11.24,-2.4507 -15.967,-5.9221 -3.1022,-2.1185 -6.0432,-4.4986 -7.5032,-7.9525 -1.9028,-4.047 -3.275,-9.4067 -2.5511,-13.954 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4258-15-8",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 334.6,354.86 c 1.403,-4.1314 2.7523,-7.9758 4.7926,-11.754 1.1745,-3.0692 3.1565,-6.1331 4.7687,-9.0028 2.8038,-2.6713 4.8762,-5.428 8.1035,-6.9022 4.8643,-2.8528 10.843,-0.2333 13.506,3.9012 1.9682,2.9726 3.9406,5.9384 4.9521,9.3029 2.8131,6.4674 3.5937,13.788 4.184,21.157 1.1881,5.9733 1.569,12.642 -1.1827,18.156 -0.86818,3.2017 -2.7064,6.8156 -5.8762,8.5872 -2.58,4.9696 -10.04,6.3248 -15.554,5.7996 -5.7634,-0.50577 -10.702,-2.7707 -15.485,-5.5476 -3.8873,-3.393 -6.8301,-7.3969 -6.0888,-12.765 -2.0539,-6.1939 1.8712,-15.268 3.8808,-20.932 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4315-5",
    transform: "matrix(-0.01610926,0.03569027,-0.03569027,-0.01610926,24.565883,115.65871)",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4286-58",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 189.3,365.01 c 0.57573,-7.0728 1.2016,-14.675 3.4515,-21.457 1.1551,-4.5503 3.4106,-8.7096 6.0026,-12.454 2.4714,-3.8699 8.1778,-6.1382 12.906,-4.3126 3.2533,1.2939 6.0561,3.833 8.1035,6.7133 3.1524,3.6637 4.6858,8.384 7.0332,12.454 2.58,5.2257 4.0104,10.982 5.7317,16.449 2.455,12.109 -0.76216,23.41 -10.678,28.817 -5.7092,3.4104 -13.792,3.9326 -20.095,1.4123 -4.3846,-1.6569 -7.1757,-5.4805 -9.4207,-9.3164 -2.9209,-5.6183 -4.222,-11.606 -3.2662,-18.123 l 0.23149,-0.18287 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4282-2",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 190.17,429.23 c 1.8305,-10.761 9.095,-19.649 18.068,-25.486 8.1612,-5.6492 16.957,-10.343 24.846,-16.299 5.0561,-5.6645 7.5158,-13.066 12.016,-19.193 7.4832,-8.8846 19.856,-11.395 30.947,-11.981 14.204,-0.51947 30.236,-0.34628 41.631,9.3822 6.5878,6.4913 8.2315,16.516 15.533,22.464 6.9948,5.5855 14.891,9.5602 22.212,14.701 10.092,6.723 19.494,17.094 19.513,29.944 0.2958,10.041 -3.52,19.939 -8.4946,28.495 -5.336,8.2918 -14.886,13.359 -24.779,12.629 -10.358,0.13126 -19.625,-5.5392 -29.789,-6.2218 -10.044,2.4158 -20.507,3.8886 -30.939,3.5049 -9.943,0.68229 -19.614,-2.4005 -29.261,-3.4278 -11.993,2.088 -23.85,8.0595 -36.291,5.5099 -11.182,-2.586 -18.883,-12.441 -21.998,-23.085 -2.3944,-6.5221 -4.7622,-13.984 -3.2138,-20.936 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4268-9",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 222.31,321.2 c 0.35791,-8.8604 1.8491,-17.553 3.9066,-26.22 3.4303,-11.533 7.3346,-25.939 19.845,-30.408 11.895,-1.8783 19.499,10.821 23.57,20.379 5.7808,13.224 9.8212,27.381 11.185,41.782 0.72297,13.299 -11.116,22.493 -23.192,24.413 -11.061,3.3232 -24.427,-0.33332 -30.314,-10.858 -3.7042,-5.7082 -5.1121,-12.919 -5.0019,-19.088 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4262-8",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 284.14,324.2 c 1.1101,-6.749 1.7937,-13.908 4.2018,-20.106 0.52034,-5.2025 3.5818,-9.599 4.4487,-14.672 2.6875,-3.2749 2.4681,-7.3816 5.4555,-10.236 1.4416,-3.251 3.3717,-6.333 6.0026,-9.0028 2.058,-2.5262 5.0822,-4.4229 8.3036,-5.2088 4.6767,-2.4883 9.1451,0.82347 12.705,3.1081 2.1857,1.8832 2.777,4.743 5.4345,6.2082 0.8606,3.8855 3.9668,6.8457 4.4348,10.897 2.273,5.7587 4.0007,11.943 4.7761,18.431 1.5267,6.4936 2.5916,14.161 2.462,20.581 -1.1668,5.4145 -1.4331,11.203 -4.7833,15.73 -1.4742,2.6359 -4.2313,5.2373 -6.3215,7.3773 -5.9884,4.4778 -13.609,5.4768 -21.099,4.7217 -5.7445,-1.3549 -11.24,-2.4507 -15.967,-5.9221 -3.1022,-2.1185 -6.0432,-4.4986 -7.5032,-7.9525 -1.9028,-4.047 -3.275,-9.4067 -2.5511,-13.954 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4258-2",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 334.6,354.86 c 1.403,-4.1314 2.7523,-7.9758 4.7926,-11.754 1.1745,-3.0692 3.1565,-6.1331 4.7687,-9.0028 2.8038,-2.6713 4.8762,-5.428 8.1035,-6.9022 4.8643,-2.8528 10.843,-0.2333 13.506,3.9012 1.9682,2.9726 3.9406,5.9384 4.9521,9.3029 2.8131,6.4674 3.5937,13.788 4.184,21.157 1.1881,5.9733 1.569,12.642 -1.1827,18.156 -0.86818,3.2017 -2.7064,6.8156 -5.8762,8.5872 -2.58,4.9696 -10.04,6.3248 -15.554,5.7996 -5.7634,-0.50577 -10.702,-2.7707 -15.485,-5.5476 -3.8873,-3.393 -6.8301,-7.3969 -6.0888,-12.765 -2.0539,-6.1939 1.8712,-15.268 3.8808,-20.932 z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      fillRule: "evenodd"
    },
    id: "g83-4",
    transform: "matrix(0.00641288,0.01535886,-0.01535886,0.00641288,80.775362,52.280174)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3023-0",
    transform: "translate(269.81467,-650.62904)",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m -126.267,1038.85 c 22.737,50.44 15.792,102.75 -15.51,116.87 -31.303,14.12 -75.11,-15.31 -97.845,-65.74 -22.737,-50.43 -15.793,-102.745 15.51,-116.863 31.303,-14.114 75.108,15.317 97.845,65.733 z",
    id: "path3025-4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 183.155,1038.85 c -22.738,50.44 -15.793,102.75 15.512,116.87 31.303,14.12 75.106,-15.31 97.846,-65.74 22.734,-50.43 15.789,-102.745 -15.513,-116.863 -31.301,-14.114 -75.108,15.317 -97.845,65.733 z",
    id: "path3027-6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 6.7856,937.757 c 11.6548,54.069 -6.1108,103.763 -39.6787,111.003 -33.5654,7.23 -70.2249,-30.74 -81.8779,-84.804 -11.653,-54.068 6.112,-103.764 39.6792,-110.997 33.5669,-7.236 70.2246,30.729 81.8774,84.798 z",
    id: "path3029-4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 49.2676,937.803 c -11.6446,54.068 6.1084,103.767 39.6738,110.997 33.5676,7.24 70.2256,-30.73 81.8776,-84.797 11.654,-54.069 -6.109,-103.765 -39.678,-110.998 -33.5678,-7.234 -70.225,30.729 -81.8734,84.798 z",
    id: "path3031-6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m -35.2275,1118.5 c -8.1924,14.15 -46.1563,60.99 -72.4145,76.97 -26.256,15.98 -58.792,39.38 -53.332,93.11 5.457,53.74 60.575,76.74 96.8597,74.7 36.2867,-2.03 104.6993,-8.71 153.543,-1.94 48.8413,6.77 110.4863,1.64 124.9223,-49.81 14.436,-51.45 -17.85,-84.23 -43.044,-102.83 -25.193,-18.59 -67.265,-74.2 -80.2269,-99.73 -12.96,-25.52 -78.9268,-72.26 -126.3076,9.53 z",
    id: "path3033-43"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      fillRule: "evenodd"
    },
    id: "g83-7-84",
    transform: "matrix(-0.00484217,0.01592398,-0.01592398,-0.00484217,80.700675,83.449154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3023-9-00",
    transform: "translate(269.81467,-650.62904)",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m -126.267,1038.85 c 22.737,50.44 15.792,102.75 -15.51,116.87 -31.303,14.12 -75.11,-15.31 -97.845,-65.74 -22.737,-50.43 -15.793,-102.745 15.51,-116.863 31.303,-14.114 75.108,15.317 97.845,65.733 z",
    id: "path3025-3-93"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 183.155,1038.85 c -22.738,50.44 -15.793,102.75 15.512,116.87 31.303,14.12 75.106,-15.31 97.846,-65.74 22.734,-50.43 15.789,-102.745 -15.513,-116.863 -31.301,-14.114 -75.108,15.317 -97.845,65.733 z",
    id: "path3027-8-75"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 6.7856,937.757 c 11.6548,54.069 -6.1108,103.763 -39.6787,111.003 -33.5654,7.23 -70.2249,-30.74 -81.8779,-84.804 -11.653,-54.068 6.112,-103.764 39.6792,-110.997 33.5669,-7.236 70.2246,30.729 81.8774,84.798 z",
    id: "path3029-0-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 49.2676,937.803 c -11.6446,54.068 6.1084,103.767 39.6738,110.997 33.5676,7.24 70.2256,-30.73 81.8776,-84.797 11.654,-54.069 -6.109,-103.765 -39.678,-110.998 -33.5678,-7.234 -70.225,30.729 -81.8734,84.798 z",
    id: "path3031-2-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m -35.2275,1118.5 c -8.1924,14.15 -46.1563,60.99 -72.4145,76.97 -26.256,15.98 -58.792,39.38 -53.332,93.11 5.457,53.74 60.575,76.74 96.8597,74.7 36.2867,-2.03 104.6993,-8.71 153.543,-1.94 48.8413,6.77 110.4863,1.64 124.9223,-49.81 14.436,-51.45 -17.85,-84.23 -43.044,-102.83 -25.193,-18.59 -67.265,-74.2 -80.2269,-99.73 -12.96,-25.52 -78.9268,-72.26 -126.3076,9.53 z",
    id: "path3033-4-97"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      fillRule: "evenodd"
    },
    id: "g83-7-3-5",
    transform: "matrix(-0.00633097,0.0153928,-0.0153928,-0.00633097,117.47602,71.499838)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3023-9-9-6",
    transform: "translate(269.81467,-650.62904)",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m -126.267,1038.85 c 22.737,50.44 15.792,102.75 -15.51,116.87 -31.303,14.12 -75.11,-15.31 -97.845,-65.74 -22.737,-50.43 -15.793,-102.745 15.51,-116.863 31.303,-14.114 75.108,15.317 97.845,65.733 z",
    id: "path3025-3-9-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 183.155,1038.85 c -22.738,50.44 -15.793,102.75 15.512,116.87 31.303,14.12 75.106,-15.31 97.846,-65.74 22.734,-50.43 15.789,-102.745 -15.513,-116.863 -31.301,-14.114 -75.108,15.317 -97.845,65.733 z",
    id: "path3027-8-7-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 6.7856,937.757 c 11.6548,54.069 -6.1108,103.763 -39.6787,111.003 -33.5654,7.23 -70.2249,-30.74 -81.8779,-84.804 -11.653,-54.068 6.112,-103.764 39.6792,-110.997 33.5669,-7.236 70.2246,30.729 81.8774,84.798 z",
    id: "path3029-0-0-0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m 49.2676,937.803 c -11.6446,54.068 6.1084,103.767 39.6738,110.997 33.5676,7.24 70.2256,-30.73 81.8776,-84.797 11.654,-54.069 -6.109,-103.765 -39.678,-110.998 -33.5678,-7.234 -70.225,30.729 -81.8734,84.798 z",
    id: "path3031-2-3-4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204120",
      fillOpacity: 0.03,
      stroke: "none"
    },
    d: "m -35.2275,1118.5 c -8.1924,14.15 -46.1563,60.99 -72.4145,76.97 -26.256,15.98 -58.792,39.38 -53.332,93.11 5.457,53.74 60.575,76.74 96.8597,74.7 36.2867,-2.03 104.6993,-8.71 153.543,-1.94 48.8413,6.77 110.4863,1.64 124.9223,-49.81 14.436,-51.45 -17.85,-84.23 -43.044,-102.83 -25.193,-18.59 -67.265,-74.2 -80.2269,-99.73 -12.96,-25.52 -78.9268,-72.26 -126.3076,9.53 z",
    id: "path3033-4-9-8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g4315-6-5",
    transform: "matrix(-0.022871,-0.03178397,0.03178397,-0.022871,61.209883,116.08246)",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4286-5-5",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 189.3,365.01 c 0.57573,-7.0728 1.2016,-14.675 3.4515,-21.457 1.1551,-4.5503 3.4106,-8.7096 6.0026,-12.454 2.4714,-3.8699 8.1778,-6.1382 12.906,-4.3126 3.2533,1.2939 6.0561,3.833 8.1035,6.7133 3.1524,3.6637 4.6858,8.384 7.0332,12.454 2.58,5.2257 4.0104,10.982 5.7317,16.449 2.455,12.109 -0.76216,23.41 -10.678,28.817 -5.7092,3.4104 -13.792,3.9326 -20.095,1.4123 -4.3846,-1.6569 -7.1757,-5.4805 -9.4207,-9.3164 -2.9209,-5.6183 -4.222,-11.606 -3.2662,-18.123 l 0.23149,-0.18287 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4282-9-5",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 190.17,429.23 c 1.8305,-10.761 9.095,-19.649 18.068,-25.486 8.1612,-5.6492 16.957,-10.343 24.846,-16.299 5.0561,-5.6645 7.5158,-13.066 12.016,-19.193 7.4832,-8.8846 19.856,-11.395 30.947,-11.981 14.204,-0.51947 30.236,-0.34628 41.631,9.3822 6.5878,6.4913 8.2315,16.516 15.533,22.464 6.9948,5.5855 14.891,9.5602 22.212,14.701 10.092,6.723 19.494,17.094 19.513,29.944 0.2958,10.041 -3.52,19.939 -8.4946,28.495 -5.336,8.2918 -14.886,13.359 -24.779,12.629 -10.358,0.13126 -19.625,-5.5392 -29.789,-6.2218 -10.044,2.4158 -20.507,3.8886 -30.939,3.5049 -9.943,0.68229 -19.614,-2.4005 -29.261,-3.4278 -11.993,2.088 -23.85,8.0595 -36.291,5.5099 -11.182,-2.586 -18.883,-12.441 -21.998,-23.085 -2.3944,-6.5221 -4.7622,-13.984 -3.2138,-20.936 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4268-5-4",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 222.31,321.2 c 0.35791,-8.8604 1.8491,-17.553 3.9066,-26.22 3.4303,-11.533 7.3346,-25.939 19.845,-30.408 11.895,-1.8783 19.499,10.821 23.57,20.379 5.7808,13.224 9.8212,27.381 11.185,41.782 0.72297,13.299 -11.116,22.493 -23.192,24.413 -11.061,3.3232 -24.427,-0.33332 -30.314,-10.858 -3.7042,-5.7082 -5.1121,-12.919 -5.0019,-19.088 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4262-4-2",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 284.14,324.2 c 1.1101,-6.749 1.7937,-13.908 4.2018,-20.106 0.52034,-5.2025 3.5818,-9.599 4.4487,-14.672 2.6875,-3.2749 2.4681,-7.3816 5.4555,-10.236 1.4416,-3.251 3.3717,-6.333 6.0026,-9.0028 2.058,-2.5262 5.0822,-4.4229 8.3036,-5.2088 4.6767,-2.4883 9.1451,0.82347 12.705,3.1081 2.1857,1.8832 2.777,4.743 5.4345,6.2082 0.8606,3.8855 3.9668,6.8457 4.4348,10.897 2.273,5.7587 4.0007,11.943 4.7761,18.431 1.5267,6.4936 2.5916,14.161 2.462,20.581 -1.1668,5.4145 -1.4331,11.203 -4.7833,15.73 -1.4742,2.6359 -4.2313,5.2373 -6.3215,7.3773 -5.9884,4.4778 -13.609,5.4768 -21.099,4.7217 -5.7445,-1.3549 -11.24,-2.4507 -15.967,-5.9221 -3.1022,-2.1185 -6.0432,-4.4986 -7.5032,-7.9525 -1.9028,-4.047 -3.275,-9.4067 -2.5511,-13.954 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4258-9-1",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 334.6,354.86 c 1.403,-4.1314 2.7523,-7.9758 4.7926,-11.754 1.1745,-3.0692 3.1565,-6.1331 4.7687,-9.0028 2.8038,-2.6713 4.8762,-5.428 8.1035,-6.9022 4.8643,-2.8528 10.843,-0.2333 13.506,3.9012 1.9682,2.9726 3.9406,5.9384 4.9521,9.3029 2.8131,6.4674 3.5937,13.788 4.184,21.157 1.1881,5.9733 1.569,12.642 -1.1827,18.156 -0.86818,3.2017 -2.7064,6.8156 -5.8762,8.5872 -2.58,4.9696 -10.04,6.3248 -15.554,5.7996 -5.7634,-0.50577 -10.702,-2.7707 -15.485,-5.5476 -3.8873,-3.393 -6.8301,-7.3969 -6.0888,-12.765 -2.0539,-6.1939 1.8712,-15.268 3.8808,-20.932 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4315-8-9",
    transform: "matrix(0.03491937,0.0177184,-0.0177184,0.03491937,98.270364,40.311673)",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4286-3-2",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 189.3,365.01 c 0.57573,-7.0728 1.2016,-14.675 3.4515,-21.457 1.1551,-4.5503 3.4106,-8.7096 6.0026,-12.454 2.4714,-3.8699 8.1778,-6.1382 12.906,-4.3126 3.2533,1.2939 6.0561,3.833 8.1035,6.7133 3.1524,3.6637 4.6858,8.384 7.0332,12.454 2.58,5.2257 4.0104,10.982 5.7317,16.449 2.455,12.109 -0.76216,23.41 -10.678,28.817 -5.7092,3.4104 -13.792,3.9326 -20.095,1.4123 -4.3846,-1.6569 -7.1757,-5.4805 -9.4207,-9.3164 -2.9209,-5.6183 -4.222,-11.606 -3.2662,-18.123 l 0.23149,-0.18287 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4282-52-4",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 190.17,429.23 c 1.8305,-10.761 9.095,-19.649 18.068,-25.486 8.1612,-5.6492 16.957,-10.343 24.846,-16.299 5.0561,-5.6645 7.5158,-13.066 12.016,-19.193 7.4832,-8.8846 19.856,-11.395 30.947,-11.981 14.204,-0.51947 30.236,-0.34628 41.631,9.3822 6.5878,6.4913 8.2315,16.516 15.533,22.464 6.9948,5.5855 14.891,9.5602 22.212,14.701 10.092,6.723 19.494,17.094 19.513,29.944 0.2958,10.041 -3.52,19.939 -8.4946,28.495 -5.336,8.2918 -14.886,13.359 -24.779,12.629 -10.358,0.13126 -19.625,-5.5392 -29.789,-6.2218 -10.044,2.4158 -20.507,3.8886 -30.939,3.5049 -9.943,0.68229 -19.614,-2.4005 -29.261,-3.4278 -11.993,2.088 -23.85,8.0595 -36.291,5.5099 -11.182,-2.586 -18.883,-12.441 -21.998,-23.085 -2.3944,-6.5221 -4.7622,-13.984 -3.2138,-20.936 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4268-2-5",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 222.31,321.2 c 0.35791,-8.8604 1.8491,-17.553 3.9066,-26.22 3.4303,-11.533 7.3346,-25.939 19.845,-30.408 11.895,-1.8783 19.499,10.821 23.57,20.379 5.7808,13.224 9.8212,27.381 11.185,41.782 0.72297,13.299 -11.116,22.493 -23.192,24.413 -11.061,3.3232 -24.427,-0.33332 -30.314,-10.858 -3.7042,-5.7082 -5.1121,-12.919 -5.0019,-19.088 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4262-6-8",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 284.14,324.2 c 1.1101,-6.749 1.7937,-13.908 4.2018,-20.106 0.52034,-5.2025 3.5818,-9.599 4.4487,-14.672 2.6875,-3.2749 2.4681,-7.3816 5.4555,-10.236 1.4416,-3.251 3.3717,-6.333 6.0026,-9.0028 2.058,-2.5262 5.0822,-4.4229 8.3036,-5.2088 4.6767,-2.4883 9.1451,0.82347 12.705,3.1081 2.1857,1.8832 2.777,4.743 5.4345,6.2082 0.8606,3.8855 3.9668,6.8457 4.4348,10.897 2.273,5.7587 4.0007,11.943 4.7761,18.431 1.5267,6.4936 2.5916,14.161 2.462,20.581 -1.1668,5.4145 -1.4331,11.203 -4.7833,15.73 -1.4742,2.6359 -4.2313,5.2373 -6.3215,7.3773 -5.9884,4.4778 -13.609,5.4768 -21.099,4.7217 -5.7445,-1.3549 -11.24,-2.4507 -15.967,-5.9221 -3.1022,-2.1185 -6.0432,-4.4986 -7.5032,-7.9525 -1.9028,-4.047 -3.275,-9.4067 -2.5511,-13.954 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4258-6-6",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 334.6,354.86 c 1.403,-4.1314 2.7523,-7.9758 4.7926,-11.754 1.1745,-3.0692 3.1565,-6.1331 4.7687,-9.0028 2.8038,-2.6713 4.8762,-5.428 8.1035,-6.9022 4.8643,-2.8528 10.843,-0.2333 13.506,3.9012 1.9682,2.9726 3.9406,5.9384 4.9521,9.3029 2.8131,6.4674 3.5937,13.788 4.184,21.157 1.1881,5.9733 1.569,12.642 -1.1827,18.156 -0.86818,3.2017 -2.7064,6.8156 -5.8762,8.5872 -2.58,4.9696 -10.04,6.3248 -15.554,5.7996 -5.7634,-0.50577 -10.702,-2.7707 -15.485,-5.5476 -3.8873,-3.393 -6.8301,-7.3969 -6.0888,-12.765 -2.0539,-6.1939 1.8712,-15.268 3.8808,-20.932 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4315-87-2",
    transform: "matrix(0.01769039,-0.03493356,0.03493356,0.01769039,77.467654,94.317092)",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4286-87-5",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 189.3,365.01 c 0.57573,-7.0728 1.2016,-14.675 3.4515,-21.457 1.1551,-4.5503 3.4106,-8.7096 6.0026,-12.454 2.4714,-3.8699 8.1778,-6.1382 12.906,-4.3126 3.2533,1.2939 6.0561,3.833 8.1035,6.7133 3.1524,3.6637 4.6858,8.384 7.0332,12.454 2.58,5.2257 4.0104,10.982 5.7317,16.449 2.455,12.109 -0.76216,23.41 -10.678,28.817 -5.7092,3.4104 -13.792,3.9326 -20.095,1.4123 -4.3846,-1.6569 -7.1757,-5.4805 -9.4207,-9.3164 -2.9209,-5.6183 -4.222,-11.606 -3.2662,-18.123 l 0.23149,-0.18287 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4282-7-1",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 190.17,429.23 c 1.8305,-10.761 9.095,-19.649 18.068,-25.486 8.1612,-5.6492 16.957,-10.343 24.846,-16.299 5.0561,-5.6645 7.5158,-13.066 12.016,-19.193 7.4832,-8.8846 19.856,-11.395 30.947,-11.981 14.204,-0.51947 30.236,-0.34628 41.631,9.3822 6.5878,6.4913 8.2315,16.516 15.533,22.464 6.9948,5.5855 14.891,9.5602 22.212,14.701 10.092,6.723 19.494,17.094 19.513,29.944 0.2958,10.041 -3.52,19.939 -8.4946,28.495 -5.336,8.2918 -14.886,13.359 -24.779,12.629 -10.358,0.13126 -19.625,-5.5392 -29.789,-6.2218 -10.044,2.4158 -20.507,3.8886 -30.939,3.5049 -9.943,0.68229 -19.614,-2.4005 -29.261,-3.4278 -11.993,2.088 -23.85,8.0595 -36.291,5.5099 -11.182,-2.586 -18.883,-12.441 -21.998,-23.085 -2.3944,-6.5221 -4.7622,-13.984 -3.2138,-20.936 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4268-4-3",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 222.31,321.2 c 0.35791,-8.8604 1.8491,-17.553 3.9066,-26.22 3.4303,-11.533 7.3346,-25.939 19.845,-30.408 11.895,-1.8783 19.499,10.821 23.57,20.379 5.7808,13.224 9.8212,27.381 11.185,41.782 0.72297,13.299 -11.116,22.493 -23.192,24.413 -11.061,3.3232 -24.427,-0.33332 -30.314,-10.858 -3.7042,-5.7082 -5.1121,-12.919 -5.0019,-19.088 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4262-49-9",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 284.14,324.2 c 1.1101,-6.749 1.7937,-13.908 4.2018,-20.106 0.52034,-5.2025 3.5818,-9.599 4.4487,-14.672 2.6875,-3.2749 2.4681,-7.3816 5.4555,-10.236 1.4416,-3.251 3.3717,-6.333 6.0026,-9.0028 2.058,-2.5262 5.0822,-4.4229 8.3036,-5.2088 4.6767,-2.4883 9.1451,0.82347 12.705,3.1081 2.1857,1.8832 2.777,4.743 5.4345,6.2082 0.8606,3.8855 3.9668,6.8457 4.4348,10.897 2.273,5.7587 4.0007,11.943 4.7761,18.431 1.5267,6.4936 2.5916,14.161 2.462,20.581 -1.1668,5.4145 -1.4331,11.203 -4.7833,15.73 -1.4742,2.6359 -4.2313,5.2373 -6.3215,7.3773 -5.9884,4.4778 -13.609,5.4768 -21.099,4.7217 -5.7445,-1.3549 -11.24,-2.4507 -15.967,-5.9221 -3.1022,-2.1185 -6.0432,-4.4986 -7.5032,-7.9525 -1.9028,-4.047 -3.275,-9.4067 -2.5511,-13.954 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4258-15-7",
    style: {
      fill: "#204120",
      fillOpacity: 0.03
    },
    d: "m 334.6,354.86 c 1.403,-4.1314 2.7523,-7.9758 4.7926,-11.754 1.1745,-3.0692 3.1565,-6.1331 4.7687,-9.0028 2.8038,-2.6713 4.8762,-5.428 8.1035,-6.9022 4.8643,-2.8528 10.843,-0.2333 13.506,3.9012 1.9682,2.9726 3.9406,5.9384 4.9521,9.3029 2.8131,6.4674 3.5937,13.788 4.184,21.157 1.1881,5.9733 1.569,12.642 -1.1827,18.156 -0.86818,3.2017 -2.7064,6.8156 -5.8762,8.5872 -2.58,4.9696 -10.04,6.3248 -15.554,5.7996 -5.7634,-0.50577 -10.702,-2.7707 -15.485,-5.5476 -3.8873,-3.393 -6.8301,-7.3969 -6.0888,-12.765 -2.0539,-6.1939 1.8712,-15.268 3.8808,-20.932 z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTiledBackground);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tiled_background.fd133028127174170d23dd42ab3a889d.svg";